import React from 'react';
import { Row, Col } from '../../../../grid';
import { Image } from '../../../../Image';
import { Heading4, Paragraph } from '../../../../typography';
import RenderModal from './RenderModal';

const RenderCampaignHerslev = ({
  herslevBryghus,
}) => {
  if (herslevBryghus) {
    return (
      <Col xs={12}>
        <RenderModal title="Gratis smagskasse ved køb af 2 fustager">
          <Row>
            <Col xs={12} md={4} textCenter>
              <Image name="produkter-fadoel.herslev-bryghus-gaveaeske.png" maxHeight="200px" />
            </Col>
            <Col xs={12} md={8} alignCenter>
              <Heading4>Gratis smagskasse ved køb af 2 fustager</Heading4>
              <Paragraph>
                Når du køber mindst 2 fustager fra Herslev Bryghus kan du få en gratis smagskasse med din ordre.
              </Paragraph>
              <Paragraph>
                Smagskassen indeholder Herslev Øko Juleøl, Herslev Øko Stjernebryg og Herslev Øko Snefri (0,5%)
              </Paragraph>
              <Paragraph>Max 1 gratis smagskasse pr. ordre.</Paragraph>
              <Paragraph>Pant bliver lagt til i kurven.</Paragraph>
            </Col>
          </Row>
        </RenderModal>
      </Col>
    );
  }
  return (null);
};

// Export
export default RenderCampaignHerslev;
